


















import { Vue, Component, Prop, PropSync, Watch } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { scrollTo } from '@/utils/scroll-to'

@Component({
  name: 'pagination'
})
export default class extends Vue {
  // Props
  @Prop({ required: true }) private total!: number // 总条目数
  @PropSync('page', { default: 1 }) currentPage!: number // 页码 :page.sync="xxx"
  @PropSync('limit', { default: 10 }) pageSize!: number // 分页量 :limit.sync="yyy"
  @Prop({ default: () => [5, 10, 20, 50, 100] }) private pageSizes!: number[] // 分页量选项
  @Prop({ default: 'total, prev, pager, next, sizes, jumper' }) private layout!: string // 布局
  @Prop({ default: true }) private autoScroll!: boolean
  // computed
  // get currentPage() {
  //   return this.page
  // }
  // set currentPage(value) {
  //   this.$emit('update:page', value)
  // }
  // methods
  get pageInfo() {
    return AppModule.pageInfo
  }

  handleSizeChange(value: number) {
    // @pagination="func"
    this.$emit('pagination', { page: this.currentPage, limit: value })
    AppModule.SetPageInfo({ page: this.currentPage, limit: value, name: this.getRouteKey() })
    if (this.autoScroll) {
      scrollTo(0, 0)
    }
  }

  handleCurrentChange(value: number) {
    this.$emit('pagination', { page: value, limit: this.pageSize })
    AppModule.SetPageInfo({ page: value, limit: this.pageSize, name: this.getRouteKey() })
    if (this.autoScroll) {
      scrollTo(0, 0)
    }
  }

  getRouteKey() {
    const { name, query } = this.$route
    if (name === 'ContentChannel') {
      if (query && query.value) {
        let { nid, value } = query
        return [value, nid].toString()
      }
    }
    return name as string
  }

  recall() {
    let info: any = this.pageInfo[this.getRouteKey()]
    if (info) {
      this.$emit('recall', info)
      console.log(info)
    } else {
      this.$emit('recall', { limit: 20, page: 1 })
    }
  }

  created() {
    this.recall()
  }

  @Watch('$route')
  private onRouteChange() {
    // 监听路由,重复点击不改变
    this.recall()
  }
}
